import { CmmConfig, CustomEquipment, ProtocolFinal, RecordDraft } from '../../types/sharedTypeImpl.ts';
import { evalImportPositions } from './evalImportPositions.ts';
import { readCmmFile } from './readCmmFile.ts';
import { splitIntoPartGroups } from './readCmmPositions.ts';
import { CmmFileImport, CmmFileRead, FileSource } from './types.ts';

export const CMM_FILE_EXTENSIONS = ['.csv', '.xlsx', '.xlsm', '.xls'];

export async function importCmmFiles(
    protocol: ProtocolFinal,
    record: RecordDraft,
    partIndex: number,
    cmmConfigs: CmmConfig[],
    files: File[],
    fileSource: FileSource,
    options?: { ignoreInvalidPosNr?: boolean },
    cmmEquipments?: CustomEquipment[],
): Promise<CmmFileImport[]> {
    const shouldSplitIntoParts = record.measurementType === 'ioqc';

    // Read all files
    const readResults: CmmFileRead[] = [];
    for (const file of files) {
        const readResult = await readCmmFile(file, cmmConfigs, options, cmmEquipments ?? []);
        readResults.push(readResult);
    }

    // Create the result object
    const finalResults: CmmFileImport[] = [];
    for (const [index, readResult] of readResults.entries()) {
        // Split into per-part groups by detecting repeating position numbers only for IOQC imports.
        const partGroups = readResult.success && shouldSplitIntoParts ? splitIntoPartGroups(readResult.positions!) : undefined;
        const isMultiPart = shouldSplitIntoParts && (partGroups?.length ?? 0) > 1;

        // Evaluate the first (or only) part group against the current partIndex for the existing dialog
        const positionImports = readResult.success
            ? evalImportPositions(protocol, record, partIndex, isMultiPart ? partGroups![0] : readResult.positions!)
            : undefined;

        finalResults.push({
            // ...readResult,
            success: readResult.success,
            equipmentId: readResult.equipmentId!,
            errorMessage: readResult.errorMessage,
            warningMessage: readResult.warningMessage,
            hasMultipleParts: readResult.hasMultipleParts,
            // new fields
            filename: files[index].name,
            fileSource,
            isImportable: readResult.success,
            isIncluded: readResult.success && !isMultiPart,
            positions: positionImports,
            rawPartGroups: shouldSplitIntoParts && isMultiPart ? partGroups : undefined,
        });
    }

    return finalResults;
}
